/** All available EAV attribute value types */
export enum EavAttributeValueTypeEnum {
  /** Boolean value (`true` or `false`) */
  BOOLEAN = 'BOOLEAN',
  /** Numeric value */
  NUMBER = 'NUMBER',
  /** Text value */
  TEXT = 'TEXT',
  /** Date value */
  DATE = 'DATE',
  /** Timestamp (date and time) value */
  TIMESTAMP = 'TIMESTAMP',
  /** Date period value (object with two timestamps) */
  DATE_PERIOD = 'DATE_PERIOD',
  /** Attached files */
  FILES = 'FILES',
  /** One or multiple filials */
  FILIAL = 'FILIAL',
  /** One or multiple cost centers */
  COST_CENTER = 'COST_CENTER'
}
